<template>
  <div class="grid-view" style="height: 100%">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @click-more="value=>isAdvancedQuery=value"
      @advSearchItemCallBack="toAdvancedQuery"
      @simSearchItemCallBack="toSimpleQuery"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :grid-params.sync="gridParams"
        style="width: 100%; height: 100%"
        @gridReady="onGridReady"
      />
    </div>
    <div id="footer-wrapper-tab-billpayment" class="pagination-wrapper">
      <div v-show="showTotalUnverifiedAmount && rowData" :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-show="selectedDataList.length > 0">
          {{ $t('Clearing.Selected') + selectedDataList.length + ':' }}
        </span>
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :type="totalType"
          :amount-to-currency="localCurrency"
          :data-field="totalDataField"
          :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
          :rate-field="rateField"
          :ar-field="arField"
          source="bankSlipCharge"
        />
        <span v-if="showTotalUnverifiedAmount && rowData && noWriteOffChargeTotalResult.length > 0" v-text="this.$t('Billing.billingJob_totalAmountNotWrittenOff')" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
          data-field="unverifiedAmount"
          :rate-field="rateField"
          :ar-field="arField"
          source="bankSlipCharge"
          @callback="noWriteOffChargeTotalCallback"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="total"
        :page-count="pageCount"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQueryByPage"
      />
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import checkPermission from '@/utils/permission'
import { queryBankSlipChargeList, queryChargeList } from '@/api/clearing/invoice'
import { User } from '@/class/model/sys/User'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'BankSlipChargeQuery',
  components: {
    searchItem,
    chargeCurrencyTotalGroup,
    cargoTemplateSelectorDialog,
    ChargeCountGroup
  },
  props: {
    identify: { type: String, required: true, default: 'fmBankSlip' }, // ID
    configModule: { type: String, default: '1300' }, // 高级查询条件
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    rateField: { type: String, default: 'converRate' }, // 汇率字段
    jobStateParam: { type: String, default: '' }, //
    chargeStateParam: { type: String, default: '' }, //
    confirmStateParam: { type: String, default: '' }, //
    arField: { type: String, default: 'ap' }, // 收付字段
    isAr: { type: Number, default: -1 }, // 收付
    commission: { type: Number, default: 0 },
    advance: { type: Number, default: -1 },
    isNeedInvoice: { type: Number, default: -1 },
    shared: { type: Number, default: -1 },
    oversea: { type: Number, default: -1 },
    paidOff: { type: Number, default: -1 },
    hasInvoice: { type: Number, default: -1 },
    hasBilling: { type: Number, default: -1 },
    hasDiffCharge: { type: Number, default: -1 },
    showUnverifiedAmount: { type: Boolean, default: true },
    showVerifiedAmount: { type: Boolean, default: true },
    showBillingNo: { type: Boolean, default: false },
    showInvoiceNo: { type: Boolean, default: false },
    showTotalUnverifiedAmount: { type: Boolean, default: false },
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    gridConfigModule: { type: String, default: '1300001' } // 列表设置
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: true, // 是否为高级查询
      documentManage: new DocumentManage(),
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      branchChargeRole: false, // 查看全部的费用
      departmentChargeRole: false, // 查看同组的费用
      simQueryPlaceholder: '快捷检索:业务编号',
      searchItemCode: this.$t('Clearing.WaterBillClaims'),
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      selectedData: null,
      selectedDataList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 行点击事件
        onRowClicked: this.onRowClicked,
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        }
      },
      rowData: [],
      searchConditions: {
        applicationStatus: -1,
        chargeStatus: -1,
        mode: 0,
        jobStates: [0, 11, 1, 2, 3],
        chargeStates: [0, 11, 1, 2, 3],
        confirmStates: [0, 1],
        exceptKeys: []
      },
      noWriteOffChargeTotalResult: [], // 未销金额合计结果
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CargoDocList',
        data: {}
      },
      gridApi: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', width: 100, colId: 'accountId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MblNo'), field: 'jobMbl', width: 100, colId: 'jobMbl' },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'), field: 'invoiceTitle', width: 100, colId: 'invoiceTitle' },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', width: 100, colId: 'invoiceNo', hide: this.showInvoiceNo },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', width: 100, colId: 'billingNo', hide: this.showBillingNo },
        { headerName: this.$t('CargoMsg.Cargo_AccountStatementNo'), field: 'billingGroupNo', width: 100, colId: 'billingGroupNo' },
        { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'jobLob', width: 100, colId: 'jobLob',
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'jobBusinessDate', width: 100, colId: 'jobBusinessDate',
          valueFormatter: (params) => {
            return DateUtils.formatStandardDate(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'), field: 'jobVesselFlight', width: 100, colId: 'jobVesselFlight' },
        { headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'loadingPortCode', width: 100, colId: 'loadingPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.portLabelFunc(params.data, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'destinationPortCode', width: 100, colId: 'destinationPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'jobSales', width: 100, colId: 'jobSales',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Accrued'), field: 'jobIsProvisioned', width: 100, colId: 'jobIsProvisioned',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'jobOp', width: 100, colId: 'jobOp',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_FinancialDate'), field: 'accountingDate', width: 100, colId: 'accountingDate',
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DomesticOrInternational'), field: 'oversea', width: 100, colId: 'oversea',
          valueFormatter: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentType'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_Dues')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeStatus'), field: 'chargeState', width: 100, colId: 'chargeState',
          valueFormatter: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ConfirmStatus'), field: 'confirmState', width: 100, colId: 'confirmState',
          valueFormatter: (params) => {
            return ColumnUtils.chargeConfirmStateLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100, colId: 'chargeItemId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 100, colId: 'currency' },
        { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 100, colId: 'quantity',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'), field: 'amount', width: 100, colId: 'amount',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'), field: 'excludingTaxAmount', width: 100, colId: 'excludingTaxAmount',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 100, colId: 'taxAmount',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', width: 100, colId: 'jobPono' },
        { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactPerson', width: 100, colId: 'contactPerson' },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'verifiedAmount', width: 100, colId: 'verifiedAmount',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountNotWrittenOff'), field: 'unverifiedAmount', width: 100, colId: 'unverifiedAmount',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentCompany'), field: 'paymentCompany', width: 100, colId: 'paymentCompany' },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'paidOff', width: 100, colId: 'paidOff',
          valueFormatter: params => {
            return (params.data.unverifiedAmount === 0 || !params.data.unverifiedAmount) ? this.$t('CargoMsg.Cargo_CollectedInFull') : this.$t('CargoMsg.Cargo_NotCollectedInFull')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ClaimDate'), field: 'clearingDate', width: 100, colId: 'clearingDate',
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoicingMethod'), field: 'cdInvoiceMode', width: 100, colId: 'cdInvoiceMode',
          valueFormatter: (params) => {
            return ColumnUtils.invoiceModeLableFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentApplicationNo'), field: 'billPaymentNo', width: 100, colId: 'billPaymentNo' },
        { headerName: this.$t('CargoMsg.Cargo_BookingNo'), field: 'billingNo', width: 100, colId: 'billingNo' },
        { headerName: this.$t('CargoMsg.Cargo_AmountRemark'), field: 'remarks', width: 100, colId: 'remarks' }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.branchChargeRole = checkPermission(['role_query_allCharges'])
    this.departmentChargeRole = checkPermission(['role_query_departmentCharge'])
    this.searchConditions.jobStates = String(cache.config.get(this.jobStateParam)).split(',') || [0, 11, 1, 2, 3]
    this.searchConditions.chargeStates = String(cache.config.get(this.chargeStateParam)).split(',') || [0, 11, 1, 2, 3]
    this.searchConditions.confirmStates = String(cache.config.get(this.confirmStateParam)).split(',') || [0, 1]
    this.setLocalCurrency()
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    refreshPageHandler() {
      this.doAdvancedQuery()
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    scrollCallback() {},
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    async doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.filterJson.requires = []
      if (this.isAr !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', this.isAr === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.commission !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.COMMISSION', this.commission === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.advance !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.isNeedInvoice !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.NEED_INVOICE', this.isNeedInvoice === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }

      if (this.shared !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.SHARED', this.shared === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.oversea > -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.paidOff > -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.PAID_OFF', this.paidOff === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', this.filterJson.conditions)) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, this.hasInvoice === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code))
      }
      if (this.hasBilling !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.BILLING', null, this.hasBilling === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code))
      }
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      if (this.hasDiffCharge !== -1) {
        const operator = this.hasDiffCharge === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.DIFF_CHARGE', null, operator))
      }
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', this.filterJson.conditions)) {
        if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0) {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, AdvancedSearchConsts.OPERATOR_IN.code))
        } else {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 11, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code))
        }
      }
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', this.filterJson.conditions)) {
        if (this.searchConditions.chargeStates && this.searchConditions.chargeStates.length > 0) {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.CHARGE_STATE', this.searchConditions.chargeStates, AdvancedSearchConsts.OPERATOR_IN.code))
        } else {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.CHARGE_STATE', [0, 11, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code))
        }
      }
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', this.filterJson.conditions)) {
        if (this.searchConditions.confirmStates && this.searchConditions.confirmStates.length > 0) {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', this.searchConditions.confirmStates, AdvancedSearchConsts.OPERATOR_IN.code))
        } else {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', [0, 1], AdvancedSearchConsts.OPERATOR_IN.code))
        }
      }

      if (this.exceptKeys && this.exceptKeys.length > 0) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.uuid', this.exceptKeys, AdvancedSearchConsts.OPERATOR_NOT_IN.code))
      }

      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.requestSource = 'BankSlipCharge'
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      if (this.branchChargeRole) {
        queryBankSlipChargeList(this.filterJson).then(res => {
          this.handleQueryData(res)
        }).finally(() => {
          this.loading.close()
        })
      } else {
        if (this.departmentChargeRole) {
          await this.getUserDepartmentTeamHandler(this.filterJson)
        } else {
          this.queryDataRole(this.filterJson, false)
        }
      }
    },
    async getUserDepartmentTeamHandler(filterJson) {
      const resData = await User.getUserDepartmentTeam()
      if (resData != null && resData.length > 0) {
        this.queryDataRole(filterJson, true, resData)
      }
    },
    queryDataRole(filterJson, isDepartment, resData) {
      const roleMap = this.getRoleByOpUsers(filterJson, isDepartment, resData)
      const roleOp = roleMap['roleOp']
      const roleSales = roleMap['roleSales']
      const auditors = roleMap['auditors']
      AdvancedSearchOption.removeOption('job.op', filterJson)
      AdvancedSearchOption.removeOption('job.sales', filterJson)
      AdvancedSearchOption.removeOption('charge.auditor', filterJson)
      filterJson.roleMap = {
        'roleOp': roleOp,
        'roleSales': roleSales,
        'auditors': auditors
      }
      queryChargeList(filterJson).then(res => {
        this.handleQueryData(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    getRoleByOpUsers(filterJson, isDepartment, resData) {
      const userId = this.$store.getters.userInfo.userId
      const role = {}
      let roleOp = []
      let roleSales = []
      const auditors = []
      if (AdvancedSearchOption.hasField('job.OP', filterJson) && AdvancedSearchOption.hasField('job.SALES', filterJson)) {
        const searchOp = AdvancedSearchOption.getOption('job.OP', filterJson)
        const searchSales = AdvancedSearchOption.getOption('job.SALES', filterJson)
        if (!isDepartment) {
          if (searchOp.value === userId) {
            roleOp.push(userId)
          } else {
            roleOp.push(-1)
          }
          if (searchSales.value === userId) {
            roleSales.push(userId)
          } else {
            roleSales.push(-1)
          }
        } else {
          if (resData != null && resData.length > 0) {
            if (resData.contains(searchOp.value)) {
              roleOp.push(searchOp.value)
            } else {
              if (searchOp.value === userId) {
                roleOp.push(userId)
              } else {
                roleOp.push(-1)
              }
            }
            if (resData.contains(searchSales.value)) {
              roleSales.push(searchSales.value)
            } else {
              if (searchSales.value === userId) {
                roleSales.push(userId)
              } else {
                roleSales.push(-1)
              }
            }
          }
        }
      } else if (AdvancedSearchOption.hasField('job.OP', filterJson) && !AdvancedSearchOption.hasField('job.SALES', filterJson)) {
        const searchOp1 = AdvancedSearchOption.getOption('job.OP', filterJson)
        if (!isDepartment) {
          if (searchOp1.value === userId) {
            roleOp.push(userId)
          } else {
            roleOp.push(-1)
          }
        } else {
          if (resData != null && resData.length > 0) {
            if (resData.contains(searchOp1.value)) {
              roleOp.push(searchOp1.value)
            } else {
              if (searchOp1.value === userId) {
                roleOp.push(userId)
              } else {
                roleOp.push(-1)
              }
            }
          }
        }
        roleSales.push(-1)
      } else if (!AdvancedSearchOption.hasField('job.op', filterJson) && AdvancedSearchOption.hasField('job.SALES', filterJson)) {
        const searchSales1 = AdvancedSearchOption.getOption('job.SALES', filterJson)
        if (!isDepartment) {
          if (searchSales1.value === userId) {
            roleSales.push(userId)
          } else {
            roleSales.push(-1)
          }
        } else {
          if (resData != null && resData.length > 0) {
            if (resData.contains(searchSales1.value)) {
              roleSales.push(searchSales1.value)
            } else {
              if (searchSales1.value === userId) {
                roleSales.push(userId)
              } else {
                roleSales.push(-1)
              }
            }
          }
        }
        roleOp.push(-1)
      } else {
        if (!isDepartment || !resData) {
          roleOp.push(userId)
          roleSales.push(userId)
        } else {
          roleOp = resData
          roleSales = resData
        }
      }
      // 费用审核人
      if (AdvancedSearchOption.hasField('charge.AUDITOR', filterJson)) {
        const auditor1 = AdvancedSearchOption.getOption('charge.AUDITOR', filterJson)
        auditors.push(auditor1.value)
      }
      auditors.push(userId)

      role.roleOp = roleOp
      role.roleSales = roleSales
      role.auditors = auditors
      return role
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      for (const c of res.data.list) {
        c.businessDate = c.jobBusinessDate
        c.lob = c.jobLob
      }
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.selectedDataList = []
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.selectedData = f
            }
          }
        })
      }
    },
    showBusinessInfo(e) {
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = this.selectedData
      this.templateSelectorDialog.category = 'JOB_DETAIL'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.jobUuid }
      this.templateSelectorDialog.visible = true
    },
    noWriteOffChargeTotalCallback(data) {
      this.noWriteOffChargeTotalResult = data
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
